import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { SharedModule } from 'src/app/shared/shared.module';
import { MotorKitsSkincareComponent } from './motor-kits-skincare.component';
import { MotorKitsSkincareRoutingModule } from './motor-kits-skincare-routing.module';

@NgModule({
  imports: [CommonModule, FormsModule, ReactiveFormsModule, NgSelectModule, SharedModule, MotorKitsSkincareRoutingModule],
  declarations: [MotorKitsSkincareComponent]
})
export class MotorKitsSkincareModule {}
